var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.32,
    height: 38.32,
    fill: "none",
    viewBox: "0 0 38.32 38.32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_1927",
    x1: 7.0452,
    x2: 32.088,
    y1: 8.8636,
    y2: 31.354,
    gradientTransform: "translate(.5 .5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7BFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A5ED",
    offset: 0.46404
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDC44",
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m 19.16,38.32 c 10.582,0 19.16,-8.5784 19.16,-19.16 C 38.32,8.578 29.7417,0 19.16,0 8.578,0 0,8.5784 0,19.16 0,29.742 8.5784,38.32 19.16,38.32 Z",
    fill: "url(#paint0_linear_35_1927)",
    style: {
      fill: "#d40000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65.396 9e-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.743 25.972 13.625-13.625",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.368 25.972-13.625-13.625",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotOk);
export default __webpack_public_path__ + "static/media/icon_not_ok.cef4cd390083d2abea5a3f6dda1ce981.svg";
export { ForwardRef as ReactComponent };